import { FontSizeTokenValue } from 'designSystem/types';
import * as S from './styles';

interface FontSizeTokenPreviewProps {
	value: FontSizeTokenValue;
}

export const FontSizeTokenPreview = ({ value }: FontSizeTokenPreviewProps) => {
	const fontSize = value.length.px || value.length.numericValue * 16;
	return (
		<S.PreviewContainer>
			<S.SizeSample fontSize={fontSize}>Sample Text</S.SizeSample>
			<S.ValueText>{value.length.original}</S.ValueText>
		</S.PreviewContainer>
	);
};
